<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="37%"
    top="9vh"
    :destroy-on-close="true"
    center
  >
    <div class="content">
      <h3>兼职：{{ info.job_name }}</h3>
      <el-form
        class="form"
        label-width="100px"
        ref="form"
        :model="form"
        :rules="rules"
        size="medium"
      >
        <el-form-item label="支付人员">
          {{
            type === "salary" ? info.resume_name : info.user && info.user.name
          }}
        </el-form-item>
        <template v-if="type === 'salary'">
          <el-form-item
            label="证件类型"
            prop="id_type"
            v-if="!payPrepareInfo.person.id"
          >
            <el-select
              style="width: 100%"
              v-model="form.id_type"
              placeholder="请选择证件类型"
            >
              <el-option label="身份证" :value="1"></el-option>
              <el-option label="港澳居民往来内地通行证" :value="2"></el-option>
              <el-option
                label="台湾居民往来内地通行证识别"
                :value="3"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="证件号码"
            prop="id_no"
            v-if="!payPrepareInfo.person.id"
          >
            <el-input
              class="input-item"
              v-model="form.id_no"
              placeholder="请输入证件号码"
            />
          </el-form-item>
          <el-form-item label="收款方式"> 银行卡 </el-form-item>
          <el-form-item label="收款账号" prop="bank_card_no">
            <span v-if="payPrepareInfo.person.bank_card_no"
              >银行卡（尾号{{ form.bank_card_no.substr(-4) }}）</span
            >
            <el-input
              v-else
              class="input-item"
              v-model="form.bank_card_no"
              placeholder="请输入收款账号"
            />
          </el-form-item>
          <el-form-item label="工资金额" prop="salary_amount">
            <el-input
              class="input-item"
              v-model="form.salary_amount"
              placeholder="请输入工资金额"
            >
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item label="用工服务费" prop="salary_amount">
            <el-input
              class="input-item"
              v-model="form.salary_amount"
              placeholder="请输入用工服务费"
            >
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
        </template>
        <el-form-item label="支付备注" prop="note">
          <el-input
            class="input-item"
            v-model="form.note"
            placeholder="请输入备注信息"
            type="textarea"
          />
        </el-form-item>
        <el-form-item class="pay-item" label="支付方式" style="width: 200%">
          <div class="flex-mid">
            <template v-for="item in payWays">
              <div
                @click="selectPayWay(item.key)"
                :key="item.key"
                style="margin-right: 5px"
              >
                <p class="flex-mid pay-btn" :class="{ active: item.active }">
                  <img class="img" :src="item.icon" />
                  <span>{{ item.name }}</span>
                </p>
              </div>
            </template>
          </div>
          <p
            style="color: #fc5646; font-size: 12px; margin: 10px 0"
            v-if="payWays[0] && payWays[0].active"
          >
            账户{{ balance }}元
          </p>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        type="primary"
        @click="handlePay"
        size="medium"
        style="width: 256px"
        v-if="balance > 0"
        >立即支付</el-button
      >
      <el-button
        type="primary"
        @click="toRecharge"
        size="medium"
        style="width: 256px"
        v-else
        >立即充值</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import BaseDialog from "../BaseDialog";
// import { getToken } from '@/utils'

export default {
  name: "PayDialog",
  extends: BaseDialog,
  data() {
    return {
      title: "支付工资服务费",
      default_avatar: require("../../images/default_avatar.png"),
      type: "",
      info: {},
      company: {},
      payWays: [],
      balance: 0,
      form: {
        id_type: 1,
        id_no: "",
        bank_card_no: "",
        salary_amount: "",
      },
      payPrepareInfo: {
        person: {},
      },
      rules: {
        id_type: [
          { required: true, message: "请选择证件类型", trigger: "change" },
        ],
        id_no: [{ required: true, message: "请选择证件号码", trigger: "blur" }],
        bank_card_no: [
          { required: true, message: "请输入收款账号", trigger: "blur" },
        ],
        salary_amount: [
          {
            required: true,
            message:
              this.type === "salary" ? "请输入工资金额" : "请输入用工服务费",
            trigger: "blur",
          },
        ],
      },
    };
  },
  async mounted() {
    // this.company =
    //   this.$store.state.company ||
    //   JSON.parse(sessionStorage.getItem("company"));
    // let res = await this.$api.CommonApi.queryAccount();
    // this.balance = res.balance;
  },
  methods: {
    resetPayWays() {
      this.payWays = [
        {
          key: "balance",
          name: "账户余额",
          icon: require("../../images/pay_online.png"),
          active: true,
        },
        {
          key: "publicTrasfer",
          name: "对公转账",
          icon: require("../../images/pay_transfer.png"),
          active: false,
        },
        {
          key: "offline",
          name: "线下支付",
          icon: require("../../images/pay_outline.png"),
          active: false,
        },
      ];
    },
    async payPrepare(info) {
      let { list, total } = await this.$api.PartTimeApi.payPrepare({
        job_id: this.info.job_id,
      });
      this.payPrepareInfo = list[0];
      if (this.payPrepareInfo.person && this.payPrepareInfo.person.id) {
        this.form.bank_card_no = this.payPrepareInfo.person.bank_card_no;
      }
    },
    open(item, type) {
      this.type = type;
      this.info = item;
      console.log(this.info);
      this.payPrepare();
      this.resetPayWays();
      if (this.type === "salary") {
        this.title = "支付工资";
        this.payWays = this.payWays.slice(0, 1);
      } else {
        this.title = "支付用工服务费";
      }
      this.visible = true;
    },
    close() {
      this.visible = false;
      this.$refs.form.resetFields();
    },
    selectPayWay(key) {
      this.payWays.forEach((x) => {
        x.active = false;
        if (x.key === key) {
          x.active = true;
        }
      });
    },
    async handlePay() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let params = {
            post_id: this.info.id,
            total: this.form.salary_amount,
            note: this.form.note,
          };
          if (!(this.payPrepareInfo.person && this.payPrepareInfo.person.id)) {
            params.id_type = this.form.id_type;
            params.id_no = this.form.id_no;
            params.bank_card_no = this.form.bank_card_no;
          }
          let packets = [
            {
              ...params,
            },
          ];
          let res = await this.$api.PartTimeApi.paySalary({
            packets,
          });
          if (res) {
            this.$message.success("支付成功");
            this.close();
            this.callback && this.callback();
          } else {
            this.$message.error("支付失败");
          }
        } else {
          console.log("信息未填完整");
        }
      });
    },
    toRecharge() {
    // 	// let token = getToken()
    //   let token = ""
    //   let url = process.env.NODE_ENV === "development"
    //       ? `http://jiesuan-test.lucasgchr.cn/user-center/accountManager?redirect=user-center/accountManager&token=${token}`
    //       : `https://jiesuan.lucasgchr.cn/user-center/accountManager?redirect=user-center/accountManager&token=${token}`
    //   window.open(url, '_blank')
    }
  },
};
</script>

<style lang="scss" scoped>
.content {
  h3 {
    margin: 10px 0;
  }
  .form {
    width: 50%;
  }
  .header {
    img {
      width: 42px;
      height: 42px;
      margin-right: 10px;
    }
  }
  .pay-item {
    .pay-btn {
      box-sizing: border-box;
      padding: 24px 0 24px 29px;
      font-size: 14px;
      width: 176px;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      cursor: pointer;
      &.active {
        background: #e6f2ff;
        border: 1px solid #1989ff;
      }
      .img {
        width: 42px;
        height: 42px;
        margin-right: 10px;
      }
    }
  }
}
</style>
